import { Lock, LockOpen } from "@mui/icons-material";
import { IconButton, TextField, Typography } from "@mui/material";

export const RTFOStepdownParams = ({ lockedParams, setLockedParams, stepdownParams, setStepdownParams, setRecalculate, sdtType }) => {

  const preSandParams = [
    'preSandNumShots',
    'preSandDperf',
    'preSandBNwb',
    'preSandCd'
  ];
  const flushParams = [
    'N', 
    'Dperf', 
    'bNwb', 
    'Cd'
  ];
  const pipeFrictionParams = [
    'fcCasing1', 
    'fcCasing2', 
    'plExpCasing1', 
    'plExpCasing2'
  ];
  const preSandPipeFrictionParams = [
    'preSandFCCasing1', 
    'preSandFCCasing2', 
    'preSandPLExpCasing1', 
    'preSandPLExpCasing2'
  ];

  return (
    <div style={{marginTop: 20}}>
      <div style={{marginTop: 20, display: 'flex', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <Typography style={{width: 150, fontSize: '16px'}}>Pre Sand</Typography>

        {preSandParams?.map(param => {
          return (
            <div style={{display: 'flex', alignItems: 'center', width: 250}} key={param}>
              <Typography style={{marginRight: 10, width: 100, fontSize: '12px'}}>{getName(param)}:</Typography>
              <TextField 
                type="string" 
                InputProps={{style: {height: '28px', fontSize: '12px'}}}
                variant="outlined" 
                value={getValue(param)} 
                style={{width: 150, marginRight: 5}} 
                sx={{ input: { color: isOutOfRange(param) && 'red' } }}
                onChange={e => handleParamChange(param, e.target.value)}
                onFocus={event => {
                  event.target.select();
                }}
                error={isOutOfRange(param)}
              />
              <IconButton color="primary" onClick={() => handleParamLock(param)}>{lockedParams?.indexOf(param) === -1 ? <LockOpen /> : <Lock />}</IconButton>
            </div>
          )
        })}
      </div>

      <div style={{marginTop: 20, display: 'flex', justifyContent: 'space-evenly', alignItems: 'center'}}>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <Typography style={{width: 150, fontSize: '16px'}}>Pre Sand Pipe Friction Model</Typography>
        </div>
        {preSandPipeFrictionParams?.map(param => {
          return (
            <div style={{display: 'flex', alignItems: 'center', width: 250}} key={param}>
              <Typography style={{marginRight: 10, width: 100, fontSize: '12px'}}>{getName(param)}:</Typography>
              <TextField 
                type="string" 
                InputProps={{style: {height: '28px', fontSize: '12px'}}}
                variant="outlined" 
                value={getValue(param)} 
                style={{width: 150, marginRight: 5}} 
                sx={{ input: { color: isOutOfRange(param) && 'red' } }}
                onChange={e => handleParamChange(param, e.target.value)}
                onFocus={event => {
                  event.target.select();
                }}
                error={isOutOfRange(param)}
              />
              <IconButton color="primary" onClick={() => handleParamLock(param)}>{lockedParams?.indexOf(param) === -1 ? <LockOpen /> : <Lock />}</IconButton>
            </div>
          )
        })}
      </div>

      <div style={{marginTop: 20, display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', color: sdtType === 'preSand' && 'grey'}}>
        <Typography style={{width: 150, fontSize: '16px'}}>Flush</Typography>
        {flushParams?.map(param => {
          return (
            <div style={{display: 'flex', alignItems: 'center', width: 250}} key={param}>
              <Typography style={{marginRight: 10, width: 100, fontSize: '12px'}}>{getName(param)}:</Typography>
              <TextField 
                type="string" 
                InputProps={{style: {height: '28px', fontSize: '12px'}}}
                variant="outlined"
                value={getValue(param)} 
                style={{width: 150, marginRight: 5}} 
                sx={{ input: { color: isOutOfRange(param) && 'red' } }}
                onChange={e => handleParamChange(param, e.target.value)}
                onFocus={event => {
                  event.target.select();
                }}
                error={isOutOfRange(param)}
                disabled={sdtType === 'preSand'}
              />
              <IconButton color="primary" onClick={() => handleParamLock(param)} disabled={sdtType === 'preSand'}>{lockedParams?.indexOf(param) === -1 ? <LockOpen /> : <Lock />}</IconButton>
            </div>
          )
        })}
      </div>

      <div style={{marginTop: 20, display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', color: sdtType === 'preSand' && 'grey'}}>
        <div style={{display: 'flex', flexDirection: 'column'}}>
          <Typography style={{width: 150, fontSize: '16px'}}>Flush Pipe Friction Model</Typography>
        </div>
        {pipeFrictionParams?.map(param => {
          return (
            <div style={{display: 'flex', alignItems: 'center', width: 250}} key={param}>
              <Typography style={{marginRight: 10, width: 100, fontSize: '12px'}}>{getName(param)}:</Typography>
              <TextField 
                type="string" 
                InputProps={{style: {height: '28px', fontSize: '12px'}}}
                variant="outlined" 
                value={getValue(param)} 
                style={{width: 150, marginRight: 5}} 
                sx={{ input: { color: isOutOfRange(param) && 'red' } }}
                onChange={e => handleParamChange(param, e.target.value)}
                onFocus={event => {
                  event.target.select();
                }}
                error={isOutOfRange(param)}
                disabled={sdtType === 'preSand'}
              />
              <IconButton color="primary" onClick={() => handleParamLock(param)} disabled={sdtType === 'preSand'}>{lockedParams?.indexOf(param) === -1 ? <LockOpen /> : <Lock />}</IconButton>
            </div>
          )
        })}
      </div>

    </div>
  );


  function getValue(param) {
    try {
      switch(param) {
        case 'numShots':
          return stepdownParams?.['numShots'] || "";
        case 'preSandNumShots':
          return stepdownParams?.['preSandNumShots'] || stepdownParams?.['numShots'] || "";
        case 'preSandDperf':
          return (stepdownParams?.['preSandDperf']) || "";
          // return (stepdownParams?.['preSandDperf'] * 25.4) || "";
          // return Number((stepdownParams?.['preSandDperf'] * 25.4)?.toFixed(2));
        case 'preSandBNwb':
          return stepdownParams?.['preSandBNwb'] || "";
          // return Number(stepdownParams?.['preSandBNwb']?.toFixed(2));
        case 'preSandCd':
          return stepdownParams?.['preSandCd'] || "";
        case 'N':
          return stepdownParams?.['N'] || "";
          // return Number(stepdownParams?.['N']?.toFixed(1));
        case 'Dperf':
          return (stepdownParams?.['Dperf']) || "";
          // return Number((stepdownParams?.['Dperf'] * 25.4)?.toFixed(2));
        case 'bNwb':
          return stepdownParams?.['bNwb'] || "";
          // return Number(stepdownParams?.['bNwb']?.toFixed(2));
        case 'Cd':
          return stepdownParams?.['Cd'] || "";
          // return Number(stepdownParams?.['Cd']?.toFixed(2));
        case 'fcCasing1':
          return stepdownParams?.['fcCasing1'] || '0.033';
          // return !isNaN(stepdownParams?.['fcCasing1']) ? Number(stepdownParams?.['fcCasing1']?.toFixed(4)) : 0.0282;
        case 'fcCasing2':
          return stepdownParams?.['fcCasing2'] || '0.085';
          // return !isNaN(stepdownParams?.['fcCasing2']) ? Number(stepdownParams?.['fcCasing2']?.toFixed(4)) : 0.0766;
        case 'plExpCasing1':
          return stepdownParams?.['plExpCasing1'] || '1.7';
          // return !isNaN(stepdownParams?.['plExpCasing1']) ? Number(stepdownParams?.['plExpCasing1']?.toFixed(4)) : 1.6823;
        case 'plExpCasing2':
          return stepdownParams?.['plExpCasing2'] || '1.701';
        case 'preSandFCCasing1':
          return stepdownParams?.['preSandFCCasing1'] || '0.033';
        case 'preSandFCCasing2':
          return stepdownParams?.['preSandFCCasing2'] || '0.085';
          // return !isNaN(stepdownParams?.['fcCasing2']) ? Number(stepdownParams?.['fcCasing2']?.toFixed(4)) : 0.0766;
        case 'preSandPLExpCasing1':
          return stepdownParams?.['preSandPLExpCasing1'] || '1.7';
          // return !isNaN(stepdownParams?.['plExpCasing1']) ? Number(stepdownParams?.['plExpCasing1']?.toFixed(4)) : 1.6823;
        case 'preSandPLExpCasing2':
          return stepdownParams?.['preSandPLExpCasing2'] || '1.701';
        default:
          return 0;
      };
    } catch (error) {
      return 0;
    };
  };

  function isOutOfRange(param) {
    try {
      switch(param) {
        case 'bNwb':
          return Number(stepdownParams?.['bNwb']) < 0.5 || Number(stepdownParams?.['bNwb']) > 1;
        case 'N':
          return Number(stepdownParams?.['N']) > Number(stepdownParams?.['numShots']);
        // case 'Dperf':
        //   return (Number(stepdownParams?.['Dperf']) < 1.1 * Number(stepdownParams?.['preSandDperf'])) || (Number(stepdownParams?.['Dperf']) > 3 * Number(stepdownParams?.['preSandDperf']));
        default:
          return (isNaN(Number(stepdownParams?.[param])) || Number(stepdownParams?.[param]) === 0) ? true : false;
      };
    } catch (error) {
      return false;
    };
  };

  function getName(param) {
    switch (param) {
      case 'numShots':
        return 'Initial Perfs';
      case 'preSandNumShots':
      case 'N':
        return 'Open Perfs';
      case 'Dperf':
      case 'preSandDperf':
        return 'Dperf (mm)';
      case 'bNwb':
      case 'preSandBNwb':
        return 'Bnwb';
      case 'Cd':
      case 'preSandCd':
        return 'Cd';
      case 'fcCasing1':
      case 'preSandFCCasing1':
        return 'PL Coeff 1';
      case 'fcCasing2':
      case 'preSandFCCasing2':
        return 'PL Coeff 2';
      case 'plExpCasing1':
      case 'preSandPLExpCasing1':
        return 'PL Exp 1';
      case 'plExpCasing2':
      case 'preSandPLExpCasing2':
        return 'PL Exp 2'
      default:
        return param;
    };
  };

  function handleParamChange(param, value) {
    try {

      let newValue = value;


      if (value?.charAt(0) === '.') {
        newValue = '0.'.concat(value?.substring(1, ));
      };

      // newValue = (parseFloat(newValue) > 0 && newValue?.charAt(newValue?.length - 1) !== '.') ? parseFloat(newValue) : newValue;
      
      // console.log(newValue);

      // if ((param === 'Dperf' || param === 'preSandDperf') && parseFloat(newValue) > 0 && newValue?.charAt(newValue?.length - 1) !== '.') {
      //   newValue = parseFloat(newValue) / 25.4;
      // };

      setStepdownParams({...stepdownParams, [param]: newValue});
      setRecalculate(true);
    } catch (error) {
      console.log(error);
    };
  };

  function handleParamLock(param) {
    try {
      if (lockedParams?.indexOf(param) === -1) {
        setLockedParams(prev => [...prev, param]);
      } else {
        setLockedParams(prev => prev.filter(p => p !== param));
      };
      setRecalculate(true);
    } catch (error) {
      console.log(error);
    };
  };
};